export const Cookie = ({
  width,
  height,
  className,
}: {
  width?: string;
  height?: string;
  className?: string;
}) => (
  <svg
    className={className}
    width={width || "144"}
    height={height || "144"}
    viewBox="0 0 144 144"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M70.8731 24.7798C48.6702 29.5064 32 49.4604 32 73.3589C32 100.775 53.938 122.999 81 122.999C108.062 122.999 130 100.775 130 73.3589C130 66.6744 128.696 60.2985 126.331 54.4781C124.12 56.6082 121.192 57.9047 117.981 57.9047C115.505 57.9047 113.358 56.9681 111.256 52.9939C109.429 56.9681 103.836 56.9681 101.34 56.9681C90.7075 56.9681 81.4623 46.6944 81.4623 34.0211C81.4623 33.4421 81.4834 32.8682 81.525 32.3C80.5319 32.8021 79.4117 33.0846 78.2264 33.0846C74.1416 33.0846 70.8302 29.7299 70.8302 25.5917C70.8302 25.3174 70.8447 25.0465 70.8731 24.7798Z"
      fill="#F1C15F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M50.2493 34.709C43.4613 43.2277 39.3969 54.0664 39.3969 65.8669C39.3969 93.2826 61.3349 115.507 88.3969 115.507C100.043 115.507 110.74 111.392 119.148 104.517C110.165 115.79 96.4137 123 81 123C53.938 123 32 100.775 32 73.3595C32 57.7418 39.1192 43.8087 50.2493 34.709Z"
      fill="#DEAD50"
    />
    <path
      d="M109.66 34.2555C109.66 37.2298 103.989 40.3434 100.415 40.3434C96.8404 40.3434 96.7166 37.2298 96.7166 34.2555C96.7166 31.2811 99.614 28.8699 103.188 28.8699C106.762 28.8699 109.66 31.2811 109.66 34.2555Z"
      fill="#F1C15F"
    />
    <path
      d="M66.2078 50.178C66.2078 53.1523 60.5367 56.266 56.9625 56.266C53.3883 56.266 53.2644 53.1523 53.2644 50.178C53.2644 47.2037 56.1619 44.7925 59.7361 44.7925C63.3103 44.7925 66.2078 47.2037 66.2078 50.178Z"
      fill="#DEAD50"
    />
    <path
      d="M66.6695 49.2414C66.6695 52.2157 60.9984 55.3293 57.4242 55.3293C53.85 55.3293 53.7261 52.2157 53.7261 49.2414C53.7261 46.267 56.6236 43.8558 60.1978 43.8558C63.772 43.8558 66.6695 46.267 66.6695 49.2414Z"
      fill="#604000"
    />
    <path
      d="M95.8844 66.4831C97.8595 67.8586 97.4028 73.0184 95.8119 75.3629C94.221 77.7073 92.0983 76.3487 90.1232 74.9732C88.1482 73.5978 87.8368 70.5821 89.4277 68.2377C91.0186 65.8932 93.9094 65.1077 95.8844 66.4831Z"
      fill="#DEAD50"
    />
    <path
      d="M96.8089 65.5465C98.784 66.922 98.3273 72.0818 96.7364 74.4263C95.1455 76.7707 93.0228 75.4121 91.0478 74.0366C89.0727 72.6612 88.7613 69.6455 90.3522 67.3011C91.9431 64.9566 94.8339 64.171 96.8089 65.5465Z"
      fill="#604000"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M108.74 36.4361C106.771 38.1328 103.626 39.4069 101.34 39.4069C97.7658 39.4069 97.6419 36.2932 97.6419 33.3189C97.6419 32.24 98.0231 31.2352 98.6796 30.3927C97.4694 31.3713 96.7175 32.7403 96.7175 34.2554C96.7175 37.2298 96.8414 40.3434 100.416 40.3434C103.107 40.3434 106.987 38.5781 108.74 36.4361Z"
      fill="#DEAD50"
    />
    <path
      d="M122.444 22.3729C124.188 23.4402 124.023 27.8942 122.769 29.9972C121.514 32.1002 119.646 31.0558 117.902 29.9885C116.158 28.9212 115.762 26.3512 117.016 24.2482C118.27 22.1452 120.7 21.3056 122.444 22.3729Z"
      fill="#F1C15F"
    />
    <path
      d="M62.8125 74.3548C64.5562 75.4221 64.3914 79.8761 63.1371 81.9791C61.8829 84.0821 60.0141 83.0378 58.2705 81.9705C56.5268 80.9032 56.1301 78.3332 57.3844 76.2302C58.6386 74.1272 61.0689 73.2875 62.8125 74.3548Z"
      fill="#DEAD50"
    />
    <path
      d="M63.2752 73.4183C65.0188 74.4856 64.854 78.9396 63.5998 81.0426C62.3455 83.1456 60.4767 82.1013 58.7331 81.034C56.9895 79.9667 56.5927 77.3966 57.847 75.2936C59.1012 73.1906 61.5315 72.351 63.2752 73.4183Z"
      fill="#604000"
    />
    <path
      d="M109.038 87.1985C110.992 86.6147 114.126 89.7429 114.812 92.0996C115.498 94.4563 113.476 95.1491 111.522 95.7329C109.568 96.3167 107.428 94.8794 106.742 92.5227C106.056 90.166 107.084 87.7822 109.038 87.1985Z"
      fill="#DEAD50"
    />
    <path
      d="M109.2 86.2665C111.154 85.6827 114.288 88.8109 114.974 91.1677C115.66 93.5244 113.638 94.2172 111.684 94.801C109.73 95.3847 107.59 93.9475 106.904 91.5908C106.218 89.234 107.246 86.8503 109.2 86.2665Z"
      fill="#604000"
    />
    <path
      d="M81.9859 97.2079C84.0094 97.4476 85.6806 101.571 85.399 104.011C85.1173 106.452 82.9894 106.285 80.966 106.046C78.9425 105.806 77.5306 103.633 77.8122 101.193C78.0939 98.7523 79.9625 96.9683 81.9859 97.2079Z"
      fill="#DEAD50"
    />
    <path
      d="M82.584 96.7839C84.6074 97.0236 86.2787 101.147 85.997 103.587C85.7154 106.028 83.5874 105.861 81.564 105.622C79.5406 105.382 78.1286 103.209 78.4103 100.769C78.692 98.3283 80.5606 96.5442 82.584 96.7839Z"
      fill="#604000"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M122.527 30.3545C121.333 31.2696 119.805 30.4028 118.364 29.5203C116.62 28.453 116.223 25.883 117.477 23.78C117.64 23.5081 117.821 23.2573 118.019 23.029C117.639 23.3668 117.298 23.7758 117.016 24.2487C115.761 26.3517 116.158 28.9217 117.902 29.989C119.537 30.9899 121.282 31.9706 122.527 30.3545Z"
      fill="#DEAD50"
    />
    <path
      d="M99.62 13.2892C100.112 15.292 96.8918 18.3295 94.5381 18.9225C92.1844 19.5154 91.5882 17.4393 91.0966 15.4365C90.6049 13.4337 93.0389 10.3928 95.3926 9.7998C97.7463 9.20684 99.1284 11.2864 99.62 13.2892Z"
      fill="#F1C15F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M98.2804 16.4926C97.2889 17.4291 96.058 18.1876 95.0017 18.4537C92.648 19.0467 92.0517 16.9706 91.5601 14.9678C91.2813 13.832 91.9434 12.3624 92.9981 11.1946C91.6841 12.4151 90.7807 14.1423 91.0983 15.4362C91.5899 17.439 92.1862 19.5151 94.5398 18.9221C95.7676 18.6128 97.231 17.6384 98.2804 16.4926Z"
      fill="#DEAD50"
    />
  </svg>
);
